<template>
	<div class="basket-form-destinations text-center" id="basket-form-destinations">
		<h4>Пункт назначения</h4>

		<div class="mt-2 d-flex justify-center">
			<v-radio-group v-model="form.destinationId" :row="isSM" @change="onSelect">
				<span v-for="(item, index) of destinations" :class="{'--disabled': item.id === DESTINATION_RUSSIA && (!isOtherCity || isPreorderInBasket)}">
          <v-radio :label="item.label"
                   :value="item.id"
                   :key="'destination'+index"/>
          <span v-if="item.id === DESTINATION_RUSSIA && (!isOtherCity || isPreorderInBasket)" class="basket-form-destinations__warning" v-html="otherCityWarning"></span>
        </span>
			</v-radio-group>
<!--      <p v-if="isOtherCity">Выберите вариант получения заказа</p>
      <p v-else-if="city">Выберите вариант получения заказа в г. {{ city }}</p>
      <p v-else>Не удалось определить город</p>-->
		</div>
		<p v-if="isCourierOnly" class="mt-2">Для выбранного пункта назначения возможна только курьерская доставка</p>
	</div>
</template>

<script>
	import vp from '@/mixins/vp';
  import {objectToArray, scrollTo} from '@/utils/utils';
	import {date2dmy} from '@/utils/date';
  import {
    destinations,
    DESTINATION_SPB,
    DESTINATION_MSK,
    DELIVERY_TYPE_EXPRESS,
    DESTINATION_RUSSIA
  } from '@/store/delivery';
  import city from "@/mixins/city";
  import config from "@/config";
  import {PAYMENT_SYSTEM_ID_CARD, PAYMENT_SYSTEM_ID_LINK, paymentSystems} from "@/store/payment";
  import metrika from "@/utils/metrika";

  let isDestinationChosen = false;

	export default {
		name: "basket-form-destinations",
		mixins: [vp, city],
		props: {
			form: {},
		},
    emits: ["paymentSystemError"],
		data() {
			return {
        lastSelectedDestinationId: null,
			}
		},
		computed: {
      DESTINATION_RUSSIA() {
        return DESTINATION_RUSSIA
      },
      // товары по предзаказу доставляются только по СПб и Москве - "Другой город" недоступен
      isPreorderInBasket() {
        return !!this.$store.getters.basketPreorderDeliveryFrom;
      },
      isOtherCity() {
        return objectToArray(this.$store.state.page.BasketController?.settings)?.find(setting => setting.CODE === 'IS_OTHER_CITY');
      },
			destinations() {
        /*if (!this.isOtherCity) {
          return destinations.filter(el => el.id !== DESTINATION_RUSSIA);
        }*/

				return destinations;
			},
			destination() {
				return this.destinations.find(el => el.id === this.form.destinationId);
			},
			isCourierOnly() {
				return this.destination && !this.destination.deliveryTypeIds?.length;
			},
      deliveryToOtherCityWarning() {
        return this.$store.state.page.BasketController?.settings?.DELIVERY_TO_OTHER_CITY_WARNING?.DETAIL_TEXT;
      },
      // подсказка при наведении на недоступный пункт "Другой город"
      otherCityWarning() {
        if (this.isPreorderInBasket) return 'В корзине есть товары по предзаказу, поэтому доставка возможна только по Санкт-Петербургу и Москве';
        return this.deliveryToOtherCityWarning;
      },
      /*city() {
        return this.currentCity;
      },
      isOtherCity() {
        return this.city === config.CITIES[2].name;
      },
      findedCity() {
        if (!this.city) return null;
        const findedC = config.CITIES.find(el => el.name === this.city);
        if (!findedC) return config.CITIES[2];
        return findedC;
      }*/
		},
		methods: {
			async onSelect(destinationId) {
        if (!isDestinationChosen) {
          metrika.reachGoal('choiceDestinationBasket');
          isDestinationChosen = true;
        }

        const isPaymentSystemAvailableInDestination = paymentSystems.find(el => el.id === this.form.paymentSystemId)?.destinationIds?.includes(destinationId);

        const settings = objectToArray(this.$store.state.page.BasketController?.settings);
        let isPaymentSystemLinkAvailable = true;

        if (destinationId === DESTINATION_SPB) {
          isPaymentSystemLinkAvailable = !!settings?.find(el => el.CODE === 'IS_PAYMENT_SYSTEM_LINK_AVAILABLE_SPB');
        } else if (destinationId === DESTINATION_MSK) {
          isPaymentSystemLinkAvailable = !!settings?.find(el => el.CODE === 'IS_PAYMENT_SYSTEM_LINK_AVAILABLE_MSK');
        }

        if (!isPaymentSystemAvailableInDestination) { //  || (this.form.paymentSystemId === PAYMENT_SYSTEM_ID_LINK && !isPaymentSystemLinkAvailable) || (this.form.paymentSystemId === PAYMENT_SYSTEM_ID_CARD && isPaymentSystemLinkAvailable)
          this.$emit("paymentSystemError", destinationId);
          await this.$nextTick();
          this.form.destinationId = this.lastSelectedDestinationId;
          return;
        }

        this.form.CITY = this.destination.city; // this.destination.city !== 'Другой город' ? this.destination.city : ""
				this.form.STREET = null;
				this.form.deliveryTypeId = null;
				this.form.deliveryZoneId = null;

				setTimeout(() => {
					scrollTo("basket-form-destinations", -120);
				}, 300);

				this.$emit("select");
        this.lastSelectedDestinationId = destinationId;
			},
			fillForm() {
				//this.form.STREET = "Решетникова 15";
				this.form.destinationId = DESTINATION_SPB;
				this.form.deliveryTypeId = DELIVERY_TYPE_EXPRESS;
				this.form.deliveryZoneId = 202;
				this.form.DATE_DELIVERY = date2dmy(new Date());
				this.form.TIME = "с 10:00 до 13:00";
				this.form.CITY = this.destination?.city || "Новгород";
				this.form.STREET = "Решетникова 15";
				this.form.APT = "122";
				this.form.NAME = "PlayNext";
				this.form.EMAIL = "test@playnext.ru";
				this.form.PHONE = "+78126430280";
				this.form.COMMENTS = "тест, тест";
				this.form.hasAccepted = true;
			}
		},
    watch: {
      'form.paymentSystemId'(newValue) {
        this.lastSelectedDestinationId = null;
      }
    },
    /*watch: {
      city(newCity) {
        this.form.destinationId = this.findedCity?.destinationId || config.CITIES[2].destinationId;
        this.form.CITY = this.city ? this.city : null;
        this.form.STREET = null;
        this.form.deliveryTypeId = null;
        this.form.deliveryZoneId = null;
      }
    },
    mounted() {
      if (!this.city) {
        this.form.destinationId = null;
      } else {
        this.form.destinationId = this.findedCity.destinationId;
        this.form.CITY = this.city;
        this.form.STREET = null;
        this.form.deliveryTypeId = null;
        this.form.deliveryZoneId = null;
      }
    }*/
  }
</script>

<style lang="scss">
.basket-form-destinations {
  & .--disabled span.basket-form-destinations__warning {
    // на мобильных подсказка (nowrap, абсолютное позиционирование) вылезает за экран и даёт горизонтальный скролл
    display: none;
    @include up($sm) {
      display: block;
    }
    white-space: nowrap;
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    color: $gray !important;
    padding: 5px;
    border-radius: 5px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  & .--disabled:hover span.basket-form-destinations__warning {
    opacity: 1;
  }

  .--disabled {
    & .v-radio {
      opacity: 0.5;
      pointer-events: none !important;
    }
  }
}
</style>